"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.updateUserAppAttribute = exports.fetchSettingsAttributes = exports.fetchUserAppAttributes = void 0;

var _RequestStatusTypes = _interopRequireDefault(require("settings-ui-sdk/constants/RequestStatusTypes"));

var _RequestEpicDescriptor = _interopRequireDefault(require("settings-ui-sdk/RequestEpicDescriptor"));

var _requestEntity = _interopRequireDefault(require("settings-ui-sdk/requestEntity"));

var _actions = require("./actions");

var _API = _interopRequireDefault(require("./API"));

var _selectors = require("./selectors");

var _reduxObservable = require("redux-observable");

var fetchUserAppAttributes = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: _API.default.getAll,
  initiatingActionType: _actions.UserAppAttributeActionTypes.LOAD_ATTRIBUTES,
  requestStatusSelector: _selectors.getFetchUserAppAttributesRequestStatus,
  requestStatusTypeFilters: [_RequestStatusTypes.default.UNINITIALIZED, _RequestStatusTypes.default.SUCCEEDED, _RequestStatusTypes.default.FAILED],
  requestActions: _actions.FetchAttributes
}));
exports.fetchUserAppAttributes = fetchUserAppAttributes;
var fetchSettingsAttributes = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: _API.default.getSome,
  initiatingActionType: _actions.UserAppAttributeActionTypes.LOAD_SETTINGS_ATTRIBUTES,
  requestStatusSelector: _selectors.getFetchSettingsUserAppAttributesRequestStatus,
  requestStatusTypeFilters: [_RequestStatusTypes.default.UNINITIALIZED, _RequestStatusTypes.default.SUCCEEDED, _RequestStatusTypes.default.FAILED],
  requestActions: _actions.FetchSettingsAttributes
}));
exports.fetchSettingsAttributes = fetchSettingsAttributes;
var updateUserAppAttribute = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: _API.default.set,
  initiatingActionType: _actions.UserAppAttributeActionTypes.UPDATE_ATTRIBUTE,
  requestStatusSelector: _selectors.getUpdateUserAppAttributeRequestStatus,
  requestStatusTypeFilters: [_RequestStatusTypes.default.UNINITIALIZED, _RequestStatusTypes.default.SUCCEEDED, _RequestStatusTypes.default.FAILED],
  requestActions: _actions.UpdateAttribute
}));
exports.updateUserAppAttribute = updateUserAppAttribute;

var _default = (0, _reduxObservable.combineEpics)(fetchUserAppAttributes, fetchSettingsAttributes, updateUserAppAttribute);

exports.default = _default;